import { fetchActiveRoom } from '@framework/guards/services';
import { getFirstCorrectPermission } from '@framework/guards/utils';
import { type Handler } from '@framework/server/middleware';

import type { PERMISSIONS } from '@type/permissions';

const getCanAccessBasedOnRoomPermissions: Handler<[PERMISSIONS[]], boolean> = async (
    _ctx,
    contextMethods,
    requiredPermissions
) => {
    const { call, dropLastVisited } = contextMethods;

    const activeRoom = await call(fetchActiveRoom);

    if (!activeRoom) {
        dropLastVisited();
        return false;
    }

    const { isUserBlockedByIpFiltering } = activeRoom;

    if (
        !isUserBlockedByIpFiltering &&
        !getFirstCorrectPermission(activeRoom.memberPermissions, requiredPermissions)
    ) {
        dropLastVisited();
        return false;
    }

    return true;
};

export default getCanAccessBasedOnRoomPermissions;
